const mutualLove = {
  state: {
    mutualLoveJS: {}
  },
  mutations: {
    SET_mutualLoveJS (state, mutualLoveJS) {
      state.mutualLoveJS = mutualLoveJS
    }
  }
}

export default mutualLove



// WEBPACK FOOTER //
// ./src/store/modules/mutualLoveJS.js